import { render, staticRenderFns } from "./ModalAddNewPersonalizationItem.vue?vue&type=template&id=1eb4f90e&scoped=true"
import script from "./ModalAddNewPersonalizationItem.vue?vue&type=script&lang=js"
export * from "./ModalAddNewPersonalizationItem.vue?vue&type=script&lang=js"
import style0 from "./ModalAddNewPersonalizationItem.vue?vue&type=style&index=0&id=1eb4f90e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb4f90e",
  null
  
)

export default component.exports